module.exports = __webpack_public_path__ + "img/about.bcf197b5.png";